import dotenv from 'dotenv';
dotenv.config();

export const login = (numero_identificacion, password) => {
    return (dispatch) => {
        dispatch({type: "LOGIN_LOADING"});
        let headers = {"Content-Type": "application/json"};
        let body = JSON.stringify({numero_identificacion, password});

        return fetch(`${process.env.REACT_APP_API_URL}/users/token`, {headers, body, method: "POST"}).then((res) => {
            if(res.status === 200){
                res.json().then(res => {
                    dispatch({type: "LOGIN_SUCCESS", data: res.data.token});
                }).catch(err => {
                    dispatch({type: "LOGIN_FAILED", data: 'Ha ocurrido un error en la autenticación.'});
                });
            }else{
                dispatch({type: "LOGIN_FAILED", data: 'Ha ocurrido un error en la autenticación.'});
            }
        }).catch((err) => {
            dispatch({type: "LOGIN_FAILED", data: 'Ha ocurrido un error en la autenticación.'});
        });
    }
};

export const logout = () => {
    return (dispatch, getState) => {
        dispatch({type: 'LOGOUT_SUCCESSFUL'});
    }
};